import { transport } from 'config/transport';

export function callApiUpdateDanhMucCTPV(danhmucId, body) {
    return transport.put(`/ctpv/danhmuc/${danhmucId}`, body);
}
